import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { passCat, passCatList } from "./data";

export default function CertificateOfQualification() {
  const [dataSource, setDataSource] = useState(null);
  const [passCatDataSource, setPassCatDataSource] = useState(
    new DataSource({
      store: passCatList,
      type: "array",
      key: "id",
    })
  );

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/certQualif/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          values = {
            ...values,
            otrPassCat:
              values.passCat == "9"
                ? passCatDataSource.items().find((item) => item.id == "9").name
                : null,
          };

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/certQualif/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          values = {
            ...values,
            otrPassCat:
              values.passCat == "9"
                ? passCatDataSource.items().find((item) => item.id == "9").name
                : null,
          };

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/certQualif/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/certQualif/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newPassCat = {
      id: "9",
      name: args.text,
    };

    args.customItem = passCatDataSource
      .store()
      .insert(newPassCat)
      .then(() => passCatDataSource.load())
      .then(() => newPassCat)
      .catch((error) => {
        throw error;
      });
  };

  const calculateCellValue = (data) => {
    if (data.passCat != "9") {
      return passCat[data.passCat];
    } else {
      return data.otrPassCat;
    }
  };

  return (
    <DataGrid
      id="certificateOfQualificationGrid"
      // ref={awardsGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Certificate of Qualification"}
          confirmDeleteMessage="Are you sure you want to delete this certificate of qualification?"
        />
        <Popup
          title={"Certificate of Qualification"}
          showTitle={true}
          height="auto"
        />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="awards"
          height={"100%"}
        >
          <SimpleItem
            dataField={"title"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"명칭"} />
          </SimpleItem>
          <SimpleItem
            dataField={"org"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"발급기관"} />
          </SimpleItem>
          <SimpleItem
            dataField={"passCat"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: passCatDataSource,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomItemCreating,
            }}
          >
            <Label text={"합격구분"} />
          </SimpleItem>
          <SimpleItem
            dataField={"date"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            <Label text={"취득일"} />
          </SimpleItem>
          <SimpleItem
            dataField={"details"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
            colSpan={4}
          >
            <Label text={"상세내용"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column dataField={"title"} caption="명칭" />
      <Column dataField={"org"} caption="발급기관" />
      <Column
        dataField={"passCat"}
        caption="합격구분"
        calculateCellValue={calculateCellValue}
      >
        {/* <Lookup
                dataSource={passCatList}
                valueExpr="id"
                displayExpr={"name"}
              /> */}
      </Column>
      <Column dataField={"otrPassCat"} caption="기타합격구분" visible={false} />
      <Column
        dataField={"date"}
        caption="취득일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column dataField={"details"} caption="상세내용" />
    </DataGrid>
  );
}
